import { Link, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import './MobTabBar.css';

export interface TabDef {
  to: string;
  label: string;
  icon: ReactNode;
  badge?: number;
  /** Custom active-match. Defaults to exact-path match. */
  match?: (pathname: string) => boolean;
}

interface MobTabBarProps {
  tabs: TabDef[];
}

export function MobTabBar({ tabs }: MobTabBarProps) {
  const { pathname } = useLocation();
  return (
    <nav className="mob-tabbar" aria-label="Primary">
      {tabs.map((t) => {
        const active = t.match ? t.match(pathname) : pathname === t.to;
        return (
          <Link
            key={t.to}
            to={t.to}
            className={`mob-tabbar__tab${active ? ' is-active' : ''}`}
            aria-current={active ? 'page' : undefined}
          >
            <span className="mob-tabbar__icon">{t.icon}</span>
            <span className="mob-tabbar__label">{t.label}</span>
            {t.badge && t.badge > 0 ? (
              <span
                className="mob-tabbar__badge"
                aria-label={`${t.badge} pending`}
              >
                {t.badge > 99 ? '99+' : t.badge}
              </span>
            ) : null}
          </Link>
        );
      })}
    </nav>
  );
}
